// hooks/useCategorys.js
import { useState } from "react";
import {
    copyGroup,
    createGroup,
    editGroup,
    getGroup,
    getGroups,
    updateGroup,
} from "services/generalGroup";
import { removeGroup } from "services/products";

const useGroups = () => {
    const [options, setOptions] = useState([]);

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    // Fetch Categorys
    const fetchOptions = async (params) => {
        setLoading(true);
        try {
            const data = await getGroups(params);
            setOptions(data.results);
            return data;
        } catch (err) {
            setError(err.message || "Failed to fetch options");
        } finally {
            setLoading(false);
        }
    };

    // Create Category
    const addOption = async (newCategory) => {
        setLoading(true);
        try {
            const response = await createGroup(newCategory);
            fetchOptions();

            return response;
        } catch (err) {
            setError(err.response.data.message || "Failed to create Category");
            return err;
        } finally {
            setLoading(false);
        }
    };

    const editGroupOptions = async (id, newCategory) => {
        setLoading(true);
        try {
            const response = await editGroup(id, newCategory);
            fetchOptions();

            return response;
        } catch (err) {
            setError(err.response.data.message || "Failed to create Category");
            return err;
        } finally {
            setLoading(false);
        }
    };
    // Create Category
    const copyGroups = async (data) => {
        setLoading(true);
        try {
            const response = await copyGroup(data);

            return response;
        } catch (err) {
            setError(err.response.data.message || "Failed to create Category");
            return err;
        } finally {
            setLoading(false);
        }
    };
    const fetchgroupBYId = async (id) => {
        setLoading(true);
        try {
            const data = await getGroup(id);

            return data.order;
        } catch (err) {
            setError(err.message || "Failed to fetch products");
        } finally {
            setLoading(false);
        }
    };

    // Edit Category
    const editOption = async (updatedData) => {
        setLoading(true);
        try {
            const updated = await updateGroup(updatedData);
            fetchOptions();
            return updated;
        } catch (err) {
            setError(err.message || "Failed to update Category");
        } finally {
            setLoading(false);
        }
    };

    // Delete Category
    const deleteOption = async (id) => {
        setLoading(true);
        try {
            await removeGroup(id);
            fetchOptions();

            return true;
        } catch (err) {
            setError(err.message || "Failed to delete Category");
        } finally {
            setLoading(false);
        }
    };

    return {
        options,
        loading,
        error,
        fetchOptions,
        addOption,
        editOption,
        deleteOption,
        fetchgroupBYId,
        copyGroups,
        editGroupOptions,
    };
};

export default useGroups;
